/* VSKLO unified scroll-reveal header: one scroll owner for mobile and desktop. */
(function () {
  'use strict';

  if (window.__VSKLO_HEADER_STATE__) return;
  window.__VSKLO_HEADER_STATE__ = true;

  var state = {
    section: null,
    header: null,
    lastY: 0,
    direction: 0,
    distance: 0,
    start: 0,
    hideAfter: 0,
    frame: 0,
    editorSelected: false,
    resizeObserver: null,
    attributeObserver: null
  };
  var mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 1024px)') : null;
  var hoverMedia = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
  var rootObserver = null;

  function scrollPosition() {
    return Math.max(0, window.scrollY || window.pageYOffset || 0);
  }

  function isMobile() {
    return mobileMedia ? mobileMedia.matches : window.innerWidth <= 1024;
  }

  function isEnabled() {
    if (!state.header || !state.header.isConnected) return false;
    var mode = state.header.getAttribute('data-sticky');
    if (mode !== 'on-scroll-up' && mode !== 'always') return false;
    return !isMobile() || state.header.getAttribute('data-sticky-mobile') !== 'false';
  }

  function resetElement(section, header) {
    if (section) {
      section.classList.remove(
        'vsklo-header-reveal',
        'vsklo-header-reveal--hidden',
        'shopify-section-header-sticky',
        'shopify-section-header-hidden',
        'header-sticky',
        'scr-pass-header',
        'scroll-up',
        'animate'
      );
      section.style.removeProperty('--vsklo-reveal-height');
    }
    if (header) header.inert = false;
  }

  function show() {
    if (!state.section || !state.header) return;
    state.section.classList.remove('vsklo-header-reveal--hidden');
    state.header.inert = false;
  }

  function hide() {
    if (!state.section || !state.header) return;
    state.section.classList.add('vsklo-header-reveal--hidden');
    state.header.inert = true;
  }

  function measure() {
    if (!state.header || !state.section || !isEnabled()) return;
    var height = Math.ceil(state.header.getBoundingClientRect().height);
    var announcement = document.querySelector('.section-announcement-bar');
    var topbar = document.querySelector('.section-top-bar');
    state.start = (announcement ? announcement.offsetHeight : 0) +
      (topbar ? topbar.offsetHeight : 0);
    state.hideAfter = state.start + height;
    state.section.style.setProperty('--vsklo-reveal-height', height + 'px');
    if (document.body) document.body.style.setProperty('--height-header', height + 'px');
  }

  function overlaysOrFocusOpen() {
    if (!state.header || !state.section) return false;
    if (state.editorSelected) return true;
    var html = document.documentElement;
    var body = document.body;
    var owners = [
      'vsklo-mobile-drawer-open',
      'nav-open',
      'open-drawer',
      'open-search',
      'open-minicart'
    ];
    for (var i = 0; i < owners.length; i++) {
      if (html.classList.contains(owners[i]) || (body && body.classList.contains(owners[i]))) {
        return true;
      }
    }
    if (state.header.classList.contains('open-submenu')) return true;
    if (hoverMedia && hoverMedia.matches && state.section.matches(':hover')) return true;
    var focused = document.activeElement;
    // Never inert a focused header control, including links reached by keyboard.
    if (focused && state.header.contains(focused)) return true;
    return false;
  }

  function update() {
    if (!state.header || !state.header.isConnected || !state.section || !state.section.isConnected) {
      bind();
      return;
    }
    var y = scrollPosition();
    var delta = y - state.lastY;
    state.lastY = y;

    if (!isEnabled()) {
      resetElement(state.section, state.header);
      state.direction = 0;
      state.distance = 0;
      return;
    }

    state.section.classList.add('vsklo-header-reveal');
    state.section.classList.toggle('shopify-section-header-sticky', y > state.start + 2);

    if (y <= state.hideAfter || state.header.getAttribute('data-sticky') === 'always' ||
        overlaysOrFocusOpen()) {
      show();
      state.direction = 0;
      state.distance = 0;
      return;
    }

    if (delta === 0) return;
    var direction = delta > 0 ? 1 : -1;
    if (direction !== state.direction) {
      state.direction = direction;
      state.distance = 0;
    }
    state.distance += Math.abs(delta);

    if (direction > 0 && state.distance >= 16) hide();
    if (direction < 0 && state.distance >= 8) show();
  }

  function schedule() {
    if (state.frame) return;
    state.frame = window.requestAnimationFrame(function () {
      state.frame = 0;
      update();
    });
  }

  function observeHeader() {
    if (state.resizeObserver) state.resizeObserver.disconnect();
    if (state.attributeObserver) state.attributeObserver.disconnect();

    if (typeof window.ResizeObserver === 'function') {
      state.resizeObserver = new ResizeObserver(function () {
        measure();
        schedule();
      });
      state.resizeObserver.observe(state.header);
      var announcement = document.querySelector('.section-announcement-bar');
      var topbar = document.querySelector('.section-top-bar');
      if (announcement) state.resizeObserver.observe(announcement);
      if (topbar) state.resizeObserver.observe(topbar);
    }
    if (typeof window.MutationObserver === 'function') {
      state.attributeObserver = new MutationObserver(function () { bind(); });
      state.attributeObserver.observe(state.header, {
        attributes: true,
        attributeFilter: ['data-sticky', 'data-sticky-mobile']
      });
    }
  }

  function bind() {
    var header = document.querySelector('.section-header .header[data-sticky]');
    var section = header ? header.closest('.section-header') : null;
    var changed = header !== state.header || section !== state.section;

    if (changed) {
      if (state.resizeObserver) state.resizeObserver.disconnect();
      if (state.attributeObserver) state.attributeObserver.disconnect();
      resetElement(state.section, state.header);
      state.header = header;
      state.section = section;
      state.lastY = scrollPosition();
      state.direction = 0;
      state.distance = 0;
    }
    if (!header || !section) return;
    // Keep an attribute observer even when Off, so Shopify editor changes
    // take effect without a full page reload.
    if (changed) observeHeader();
    if (!isEnabled()) {
      resetElement(section, header);
      return;
    }

    var wasEnabled = section.classList.contains('vsklo-header-reveal');
    section.classList.remove('shopify-section-header-hidden', 'header-sticky', 'scr-pass-header', 'scroll-up', 'animate');
    section.classList.add('vsklo-header-reveal');
    measure();
    if (changed || !wasEnabled) {
      show();
      section.classList.toggle('shopify-section-header-sticky', state.lastY > state.start + 2);
    } else {
      // Ignore unrelated section editor events without flashing the header.
      schedule();
    }
  }

  function onResize() {
    if (state.header && !isEnabled()) {
      resetElement(state.section, state.header);
    } else {
      measure();
    }
    state.direction = 0;
    state.distance = 0;
    schedule();
  }

  function onSectionUnload(event) {
    if (!state.section || !event.target ||
      (event.target !== state.section && !event.target.contains(state.section))) return;
    if (state.resizeObserver) state.resizeObserver.disconnect();
    if (state.attributeObserver) state.attributeObserver.disconnect();
    resetElement(state.section, state.header);
    state.header = null;
    state.section = null;
    state.editorSelected = false;
  }

  function onSectionSelect(event) {
    if (state.section && event.target &&
      (event.target === state.section || event.target.contains(state.section))) {
      state.editorSelected = true;
      show();
    }
  }

  function onSectionDeselect(event) {
    if (state.section && event.target &&
      (event.target === state.section || event.target.contains(state.section))) {
      state.editorSelected = false;
      schedule();
    }
  }

  function onReady() {
    bind();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('load', onResize, { once: true });
    window.addEventListener('pageshow', bind);
    document.addEventListener('shopify:section:load', bind);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:select', onSectionSelect);
    document.addEventListener('shopify:section:deselect', onSectionDeselect);
    document.addEventListener('shopify:section:reorder', bind);
    document.addEventListener('focusin', schedule);
    if (typeof window.MutationObserver === 'function') {
      rootObserver = new MutationObserver(schedule);
      rootObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      if (document.body) rootObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    if (mobileMedia) {
      if (mobileMedia.addEventListener) mobileMedia.addEventListener('change', bind);
      else if (mobileMedia.addListener) mobileMedia.addListener(bind);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();
